import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when the mobile app handoff QR code is shown to the user',
  name: 'mobile_app_qr_code_shown',
  params: [
    {
      description: 'Where the QR code was rendered',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['integrations', 'help-menu'],
    },
  ],
};

export default META;
